export default [
  { id: 'companies', labelStringId: 'companies', path: '/companies', icon: 'fa-thin fa-buildings' },
  { id: 'profiles', labelStringId: 'profiles', path: '/profiles', icon: 'fa-thin fa-users' },
  { id: 'apps', labelStringId: 'apps', path: '/apps', icon: 'fa-light fa-browser' },
];
